import cx from 'classnames';
import Link from 'next/link';

import { IFusyFaq } from '@/src/components/input-search-faq/useInputSearchFaq';

type IInputSearchCardProps = {
  faq: IFusyFaq[];
  hide: boolean;
  locale: string;
};

export const InputSearchFaqCard = ({
  faq,
  hide,
  locale,
}: IInputSearchCardProps) => {
  return (
    <div
      className={cx(
        hide ? 'hidden' : 'block',
        'no-scrollbar absolute inset-x-0 top-[60px] z-10 max-h-[190px] cursor-pointer overflow-y-scroll rounded-lg border bg-white p-0.5'
      )}
    >
      {faq.map(item => (
        <Link
          key={`${locale}/help/${item.categorySlug}/${item.slug}`}
          href={`/${locale}/help/${item.categorySlug}/${item.slug}`}
          onClick={() => {
            window.dataLayer?.push({
              event: 'click_button',
              click_id: `/${locale}/help/${item.categorySlug}/${item.slug}`,
              click_label: item.text,
            });
          }}
          className={
            'flex w-full items-center gap-2 rounded-lg p-4 px-6 hover:bg-overlay'
          }
        >
          {item.text}
        </Link>
      ))}
    </div>
  );
};
